import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { GymListingService } from "../../services/gymListing.service";
import { IApprovedGymsData } from "../types";
import { IGymListing } from "../../models/GymListing";

export const useGetAllApprovedGymsQuery = (data: IApprovedGymsData, userId: string | null) => {
  const key = [
    QUERY_CONSTANTS.GET_ALL_APPROVED_GYMS,
    userId,
    {
      lat: data?.userLocationLat || null,
      lng: data?.userLocationLng || null,
      dmin: data?.distanceMin ?? null,
      dmax: data?.distanceMax ?? null,
      cats: data?.categoryIds ?? [],
      facs: data?.facilities ?? [],
    },
  ] as const;

  return useQuery<IGymListing[], Error>({
    queryKey: key,
    queryFn: () => GymListingService.getAll(data, userId).then((res) => res.data),
  });
};
